import { compact } from 'fp-ts/Array';
import { RequestParams } from '~/core/api/RequestTypes';
import { GeneralFilter } from '../features/filtering/GeneralFilter';
import { InitialPagination } from '../features/pagination/types/initialPagination.type';
import { State } from '../state/types/state';

/**
 * Get request parameters for new search - crucial for fetching new search results
 *
 * @returns request parameters for new search
 */
const getNewRequestParams = (
    stateSets: State['sets'],
    stateControls: State['controls'],
    initialPagination: InitialPagination | null
): RequestParams => {
    const filter = new GeneralFilter();
    return stateSets.map((querySetState) => {
        const querySetControls = stateControls.find(
            (controls) => controls.querySet.identifier === querySetState.querySet.identifier
        );
        return {
            name: querySetState.querySet.identifier, // TODO: correct variable name in SRD-502, why is it called name and not identifier like everywhere else?
            from: 0,
            size: initialPagination?.[querySetState.querySet.identifier]?.size ?? querySetState.size,
            indices: querySetControls?.indices
                ? querySetControls.indices.filter((index) => index.isChecked).map((index) => index.identifier)
                : undefined,
            filters: querySetControls?.filters
                ? compact(querySetControls.filters.map(filter.createRequestPayloadFromState))
                : undefined,
            sort: querySetControls?.sorting ? querySetControls.sorting : null, // TODO: correct in SRD-502 - why sort has to be null, but indices and filters can be undefined?
        };
    });
};

export default getNewRequestParams;
